// Tixologi token exchange — shared contract between the client hook
// (hooks/tixologi/useTixologiTokenExchange) and the API route
// (app/(public)/api/v2/user/tixologi/token), which forwards to Tixologi's
// scope-explicit POST /punchup/token.

/**
 * What the minted Tixologi token is scoped to. Each value maps to a distinct
 * claim set on Tixologi's `POST /punchup/token`:
 *
 * - `ComedianManager` → partner (producer) claims for a comedian the caller
 *   manages (`{ email, scope, comedian_id }`).
 * - `VenueManager` → partner (producer) claims for a venue the caller
 *   manages (`{ email, scope, venue_page_id }`).
 * - `User` → an end-user token with user-identity claims only — no
 *   partner/member claims — available to any logged-in user
 *   (`{ email, scope }`).
 */
export enum TixologiTokenScope {
  ComedianManager = "comedian_manager",
  VenueManager = "venue_manager",
  User = "user",
}

export interface TixologiTokenExchange {
  token: string;
  /**
   * The Tixologi partner id the login resolved to — Tixologi's authoritative
   * id → partner mapping. Present for the manager scopes only; an end-user
   * (`User`) token has no partner association.
   */
  partnerId?: number;
  /**
   * Statsig `tixologi_green_zone` gate, evaluated server-side per user:
   * true → the host should load the refactored "V2" tixologi build.
   * Fail-safe false.
   */
  greenZone: boolean;
}
